import { c as _c } from "react/compiler-runtime";
import ContactPanelSection from "../sections/ContactPanelSection";
import ServicingPanelSection from "../sections/ServicingPanelSection";
import MediaInquiriesSection from "../sections/MediaInquiriesSection";
import StateNoticeSection from "../sections/StateNoticeSection";
interface NavigationItem {
  id: string;
  title: string;
  type: string;
}
interface CustomerCareContentProps {
  intro?: string;
  sections: any[];
  navigationItems: NavigationItem[];
  onSectionClick: (sectionId: string) => void;
}
const CustomerCareContent = t0 => {
  const $ = _c(12);
  const {
    intro,
    sections,
    navigationItems
  } = t0;
  let t1;
  if ($[0] !== intro) {
    t1 = intro && <span className="font-[lora] text-[28px] leading-[38px] font-semibold tracking-[0.2px] text-[#00698F] md:text-[36px] md:leading-[48px]">{intro}</span>;
    $[0] = intro;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className="mb-10">{t1}</div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== navigationItems || $[5] !== sections) {
    let t4;
    if ($[7] !== navigationItems) {
      t4 = section => {
        const navItem = navigationItems.find(item => item.id === section._key);
        return <section key={section._key} id={section._key} className="mb-[26px]"><div className="my-5"><span className="text-[24px] leading-[28px] font-semibold text-[#373A36]">{navItem?.title || "Section"}</span></div>{section._type === "contactPanel" && <ContactPanelSection data={section} />}{section._type === "servicingPanel" && <ServicingPanelSection data={section} />}{section._type === "mediaInquiries" && <MediaInquiriesSection data={section} />}{section._type === "stateNotice" && <StateNoticeSection data={section} />}</section>;
      };
      $[7] = navigationItems;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    t3 = sections.map(t4);
    $[4] = navigationItems;
    $[5] = sections;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[9] !== t2 || $[10] !== t3) {
    t4 = <div>{t2}{t3}</div>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};
export default CustomerCareContent;